import { Component, Input } from "@angular/core";
import { NavParams } from "ionic-angular";
import { NavController } from "ionic-angular";
import { PaymentAddPage } from "../../pages/payment/payment_add";
import { PaymentUpdatePage } from "../../pages/payment/payment_update";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "paymentcomponent",
  templateUrl: "paymentcomponent.html"
})
export class PaymentComponent {
  public static readonly PAYMENT_PY_ADD_ACCESS = "addPayment";

  @Input() payment: any;
  @Input() paymenttype: any;
  @Input() displayPic: boolean;

  private hasAddPaymentAccess: boolean = false;
  private objectKeys = Object.keys;
  constructor(public authService: AuthService, public navParams: NavParams,
              public navCtrl: NavController, private db: DbserviceProvider) {
    console.log("PaymentComponent Component");
    if (this.authService.currentUser) {
      this.hasAddPaymentAccess = this.db.hasAccess(PaymentComponent.PAYMENT_PY_ADD_ACCESS);
    }
  }

  public addPayment(_hashname: string,_pyid: any,_pm_type: string) {
    console.log("PaymentComponent addPayment ");

    this.payment[_hashname].pm_type = _pm_type;
    this.payment[_hashname].pm_id = _pyid;
    this.payment[_hashname].py_remark = "";

    if (this.hasAddPaymentAccess) {
      this.navCtrl.push(PaymentAddPage, {
        "id": this.payment[_hashname],
      });
    }
  }

  private viewPayment(_hashname: string,_pyid: any, _pm_type: string) {
   console.log("PaymentComponent viewPayment ");

   this.payment[_hashname].pm_type = _pm_type;
   this.payment[_hashname].pm_id = _pyid;
   this.payment[_hashname].py_id = this.payment[_hashname][_pm_type + "id"];
   this.payment[_hashname].py_amount = this.payment[_hashname][_pm_type];
   this.payment[_hashname].py_remark = this.payment[_hashname]["py_remark_" + _pm_type];
   this.payment[_hashname].py_date = this.payment[_hashname]["py_date" + _pm_type];

   if (this.hasAddPaymentAccess) {
      this.navCtrl.push(PaymentUpdatePage, {
        "id": this.payment[_hashname]
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/paymentcomponent/paymentcomponent.ts